import { ReactNode } from 'react';
import { Flex, FlexProps, Box } from '@blockanalitica/ui';
import styled from 'styled-components';

const Entity = styled.div`
  margin-left: calc(${(props) => props.theme.sizes['0']} / -3);

  &:first-child {
    margin: 0;
  }
`;

export interface EntityListProps extends FlexProps {
  showTotalNumber?: boolean;
  children: ReactNode[];
}

export default function EntityList({
  showTotalNumber = true,
  children,
  ...rest
}: EntityListProps) {
  return (
    <Flex alignItems="center" gap="2xs" {...rest}>
      {showTotalNumber ? <Box>{children.length}</Box> : null}
      <Flex>
        {children.map((child, index) => (
          <Entity key={index}>{child}</Entity>
        ))}
      </Flex>
    </Flex>
  );
}
